import React from 'react';
import { render } from 'react-dom';
import './PlayerComparable.css';
import axios from 'axios';
import { getHenriColor, getHenriStyle } from '../Utility/utility.js';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
export class Commentlist extends React.Component {
  render() {
    return (
      <div
        className="comparable-player-tile"
        style={{ backgroundColor: '#1e3c51' }}
      >
        <div className="comparable-player-bio-box">
          <div className="comparable-player-photo-box">
            <img
              className="comparable-player-photo"
              src={
                'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=' +
                this.props.player.playerName
                  .split(' ')[0]
                  .replace('.', '')
                  .replace('.', '') +
                '-' +
                this.props.player.playerName.split(' ')[1] +
                '&width=136&height=136'
              }
              alt="Smiley face"
            />
          </div>
          <div className="comparable-player-bio">
            <div>{this.props.player.playerName.split(' ')[0]}</div>
            <div>{this.props.player.playerName.split(' ')[1]}</div>
            <div style={{ borderTop: '2px solid #94b1c5', color: '#94b1c5' }}>
              {this.props.player.league}|{this.props.player.seasonAge}
            </div>
          </div>
        </div>
        <div className="comparable-player-stats-list">
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#1e3c51' }}
          >
            <div className="comparable-player-stat-name">Season:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.season}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">PTS:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.p}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#1e3c51' }}
          >
            <div className="comparable-player-stat-name">PPG:</div>
            <div className="comparable-player-stat-value">
              {this.props.player.ppg ? this.props.player.ppg.toFixed(3) : null}
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">TO %:</div>
            <div className="comparable-player-stat-value">
              <span style={{ fontWeight: 'bold' }}>
                {this.props.player.toPct
                  ? (this.props.player.toPct * 100).toFixed(2)
                  : null}
              </span>
            </div>
          </div>
          <div
            className="comparable-player-stat-entry"
            style={{ backgroundColor: '#526978' }}
          >
            <div className="comparable-player-stat-name">HENRI:</div>
            <div className="comparable-player-stat-value">
              <span
                style={{
                  color: getHenriStyle(getHenriColor(this.props.player.henri)),
                  fontWeight: 'bold'
                }}
              >
                {getHenriColor(this.props.player.henri).toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class PlayerComparable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playerComp1: [],
      playerComp2: []
    };
  }
  componentDidUpdate() {
    let component = this;
    //if there are no comparables, skip this section
    if (
      !this.props.selectedPlayer.comparables.nhlComparable1 &&
      !this.props.selectedPlayer.comparables.nhlComparable2
    ) {
      return;
    }
    //console.log(" player 1" + JSON.stringify(this.props.selectedPlayer.comparables.nhlComparable1));
    //console.log(" player 2" + JSON.stringify(this.props.selectedPlayer.comparables.nhlComparable2));
    let player1 = [];
    let player2 = [];
    //let component = this;
    axios
      .all([
        axios
          .get(
            apiServerUrl +
              '/comparable_stats?playerID=' +
              this.props.selectedPlayer.comparables.nhlComparable1,
            requestOptions()
          )
          .catch(function() {
            //console.log("request one failed");
            return 'failure';
          }),
        axios
          .get(
            apiServerUrl +
              '/comparable_stats?playerID=' +
              this.props.selectedPlayer.comparables.nhlComparable2,
            requestOptions()
          )
          .catch(function() {
            //console.log("request two failed");
            return 'failure';
          })
      ])
      .then(
        axios.spread(function(res1, res2) {
          //console.log("response one " + JSON.stringify(res1));
          //console.log("response two" + JSON.stringify(res2));
          if (res1 != 'failure' && res2 != 'failure') {
            if (
              res1.data.playerID != component.state.playerComp1.playerID ||
              res2.data.playerID != component.state.playerComp2.playerID
            ) {
              component.setState(prevState => ({
                playerComp1: res1.data,
                playerComp2: res2.data
              }));
            }
          } else if (res1 == 'failure' && res2 == 'failure') {
            //console.log("double failure")
            component.setState(prevState => ({
              playerComp1: '',
              playerComp2: ''
            }));
          } else if (res1 == 'failure') {
            //console.log("response one failed");
            //make sure response two didnt fail
            if (
              res2.data != 'failure' &&
              res2.data.playerID != component.state.playerComp2.playerID
            ) {
              component.setState(prevState => ({
                playerComp1: '',
                playerComp2: res2.data
              }));
            }
          } else if (res2 == 'failure') {
            if (
              res1.data != 'failure' &&
              res1.data.playerID != component.state.playerComp1.playerID
            ) {
              component.setState(prevState => ({
                playerComp1: res1.data,
                playerComp2: ''
              }));
            }
          }
        })
      );
  }
  render() {
    return (
      <div
        className="comparable-body"
        style={{ border: '0.2em solid #6e777d', borderRadius: '5px' }}
      >
        <div className="comparable-header">
          <span>PLAYER COMPARABLES</span>
        </div>
        <div className="comparable-content">
          {this.state.playerComp1.playerID &&
            this.props.selectedPlayer.comparables.nhlComparable1 && (
              <Commentlist player={this.state.playerComp1} />
            )}

          <div
            className="comparable-player-tile"
            style={{ backgroundColor: '#1e3c51' }}
          >
            <div className="comparable-player-bio-box">
              <div className="comparable-player-photo-box">
                <img
                  className="comparable-player-photo"
                  src={this.props.selectedPlayer.biographical.imageUrl}
                  alt="Smiley face"
                />
              </div>
              <div className="comparable-player-bio">
                <div>{this.props.selectedPlayer.biographical.firstName}</div>
                <div>{this.props.selectedPlayer.biographical.lastName}</div>
                <div
                  style={{ borderTop: '2px solid #94b1c5', color: '#94b1c5' }}
                >
                  <span>
                    {this.props.selectedPlayer.biographical.currentLeague}
                  </span>
                  |{this.props.selectedPlayer.biographical.currentAge}
                </div>
              </div>
            </div>
            <div className="comparable-player-stats-list">
              <div
                className="comparable-player-stat-entry"
                style={{ backgroundColor: '#1e3c51' }}
              >
                <div className="comparable-player-stat-name">Season:</div>
                <div className="comparable-player-stat-value">2017-2018</div>
              </div>
              <div
                className="comparable-player-stat-entry"
                style={{ backgroundColor: '#526978' }}
              >
                <div className="comparable-player-stat-name">PTS:</div>
                <div className="comparable-player-stat-value">
                  {this.props.selectedPlayer.lastSeasonStats.p}
                </div>
              </div>
              <div
                className="comparable-player-stat-entry"
                style={{ backgroundColor: '#1e3c51' }}
              >
                <div className="comparable-player-stat-name">PPG:</div>
                <div className="comparable-player-stat-value">
                  {(
                    this.props.selectedPlayer.lastSeasonStats.p /
                    this.props.selectedPlayer.lastSeasonStats.gp
                  ).toFixed(2)}
                </div>
              </div>
              <div
                className="comparable-player-stat-entry"
                style={{ backgroundColor: '#526978' }}
              >
                <div className="comparable-player-stat-name">TO %:</div>
                <div className="comparable-player-stat-value">
                  <span style={{ fontWeight: 'bold' }}>
                    {this.props.selectedPlayer.lastSeasonStats.toPct &&
                      (
                        this.props.selectedPlayer.lastSeasonStats.toPct * 100
                      ).toFixed(2)}
                  </span>
                </div>
              </div>
              <div
                className="comparable-player-stat-entry"
                style={{ backgroundColor: '#526978' }}
              >
                <div className="comparable-player-stat-name">HENRI:</div>
                <div className="comparable-player-stat-value">
                  <span
                    style={{
                      color: getHenriStyle(this.props.selectedPlayer.henri),
                      fontWeight: 'bold'
                    }}
                  >
                    {this.props.selectedPlayer.henri &&
                      this.props.selectedPlayer.henri.toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {this.state.playerComp2.playerID &&
            this.props.selectedPlayer.comparables.nhlComparable2 && (
              <Commentlist player={this.state.playerComp2} />
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/PlayerComparable.js